<template>
  <v-text-field
    v-model="dateValue"
    :label="label"
    :placeholder="placeholder"
    :rules="rules"
    variant="outlined"
    density="compact"
    hide-details
    clearable
    class="date-input"
    style="max-width: 300px;"
  >
    <template v-slot:append-inner>
      <v-icon>mdi-calendar</v-icon>
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'DateInput',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: Array as () => ((v: any) => boolean | string)[],
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const dateValue = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })

    return {
      dateValue
    }
  }
})
</script>

<style scoped>
.date-input :deep(.v-field__input),
.date-input :deep(.v-field__field),
.date-input :deep(input) {
  color: #fff !important;
}

.date-input :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.date-input :deep(.v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.date-input :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.date-input :deep(.v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style> 